(() => {
  const initExpandableDescriptions = () => {
    const blocks = document.querySelectorAll('[data-nutry-expandable-description]');

    blocks.forEach((block) => {
      if (block.dataset.nutryDescriptionReady === 'true') return;

      block.dataset.nutryDescriptionReady = 'true';

      const frame = block.querySelector('[data-nutry-description-frame]');
      const content = block.querySelector('[data-nutry-description-content]');
      const button = block.querySelector('[data-nutry-description-toggle]');
      const buttonText = block.querySelector('[data-nutry-description-button-text]');
      const buttonIcon = block.querySelector('[data-nutry-description-icon]');
      const readMore = block.querySelector('[data-nutry-read-more-text]');
      const readLess = block.querySelector('[data-nutry-read-less-text]');

      if (!frame || !content || !button) return;

      const getReadMoreText = () => readMore ? readMore.textContent : 'Ler mais';
      const getReadLessText = () => readLess ? readLess.textContent : 'Ler menos';

      const checkTruncation = () => {
        if (block.classList.contains('is-expanded')) return;

        // Measure with the clamp applied: "is-not-truncated" removes the max-height, so drop it first.
        block.classList.remove('is-not-truncated');

        // Stylesheet not applied yet (no max-height): measure again later instead of deciding now.
        if (getComputedStyle(frame).maxHeight === 'none') return;

        const isTruncated = content.scrollHeight > frame.clientHeight + 4;

        block.classList.toggle('is-truncated', isTruncated);
        block.classList.toggle('is-not-truncated', !isTruncated);
        button.hidden = !isTruncated;
      };

      button.addEventListener('click', () => {
        const isExpanded = block.classList.toggle('is-expanded');

        button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

        if (buttonText) {
          buttonText.textContent = isExpanded ? getReadLessText() : getReadMoreText();
        }

        if (buttonIcon) {
          buttonIcon.textContent = isExpanded ? '−' : '+';
        }

        if (!isExpanded) {
          const header = document.querySelector('header, .header, #shopify-section-header');
          const offset = header ? header.offsetHeight + 16 : 96;
          const top = block.getBoundingClientRect().top + window.scrollY - offset;

          window.scrollTo({
            top,
            behavior: 'smooth'
          });
        }
      });

      // Images, fonts and late styles change the height after first paint, so re-check whenever it changes.
      checkTruncation();
      setTimeout(checkTruncation, 120);
      window.addEventListener('load', checkTruncation, { once: true });
      window.addEventListener('resize', checkTruncation);
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => checkTruncation()).observe(content);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExpandableDescriptions);
  } else {
    initExpandableDescriptions();
  }
  document.addEventListener('shopify:section:load', initExpandableDescriptions);
})();